<template>
  <div class="d-flex flex-wrap flex-column align-items-center">
    <a-dropdown
      :trigger="['hover']"
      placement="bottomCenter"
      :class="$style.imageWrapper"
    >
      <div
        class="kit__utils__avatar kit__utils__avatar--size64 mb-3"
        v-if="profileImage"
      >
        <img
          :src="settings.resourcesUrl.replace('FILE_PATH', profileImage)"
          :alt="fullName"
          style="width: 100%; height: 100%; object-fit: cover"
        />
      </div>
      <div
        v-else
        class="kit__utils__avatar kit__utils__avatar--size64 mb-3 bg-gray-1 d-flex align-items-center justify-content-center"
      >
        <a-icon type="user" class="font-size-24 text-gray-4" />
      </div>
      <template #overlay>
        <a-menu :class="$style.dropdownMenu">
          <a-menu-item
            v-if="profileImage"
            key="view"
            @click="imageModalVisible = true"
          >
            <a-icon type="eye" style="width: 24px; font-size: 15px" />
            {{ $t("profil.viewStudentPhoto") }}
          </a-menu-item>
          <a-menu-item key="upload" @click="$refs.fileInput.click()">
            <a-icon type="camera" style="width: 24px; font-size: 15px" />
            {{ $t("profil.uploadStudentPhoto") }}
            <input
              ref="fileInput"
              type="file"
              accept="image/jpeg,image/jpg,image/png,image/bmp"
              @change="handleImageChange"
              style="display: none"
            />
          </a-menu-item>
          <a-menu-item
            v-if="profileImage"
            key="delete"
            @click="deleteModalVisible = true"
          >
            <a-icon type="delete" style="width: 24px; font-size: 15px" />
            {{ $t("profil.removeStudentPhoto") }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <div class="text-center">
      <div class="text-dark font-weight-bold font-size-24">{{ fullName }}</div>
      <div class="text-uppercase font-size-18 mb-3">
        {{ calculateAge(birthDay) }} {{ $t("profil.years") }}
      </div>
      <button
        v-if="classRoom"
        type="button"
        class="btn btn-primary btn-disabled"
        :class="$style.btnWithAddon"
        @click="go"
      >
        <span :class="$style.btnAddon">
          <a-icon type="user" :class="$style.btnAddonIcon" />
        </span>
        {{ classRoom }}
      </button>
      <button
        v-else
        type="button"
        class="btn btn-secondary btn-disabled"
        :class="$style.btnWithAddon"
      >
        <span :class="$style.btnAddon">
          <a-icon type="user" :class="$style.btnAddonIcon" />
        </span>
        {{ $t("profil.nonInscrit") }}
      </button>
    </div>
    <a-modal
      v-model:visible="imageModalVisible"
      :footer="null"
      :width="800"
      @cancel="imageModalVisible = false"
      centered
    >
      <img
        v-if="profileImage"
        :src="settings.resourcesUrl.replace('FILE_PATH', profileImage)"
        :alt="fullName"
        style="width: 100%; height: auto; object-fit: contain"
      />
    </a-modal>
    <a-modal
      v-model:visible="uploadModalVisible"
      :title="$t('profil.uploadStudentPhoto')"
      :maskClosable="false"
      @cancel="cancelUpload"
      centered
      :closable="false"
    >
      <div class="text-center">
        <div v-if="tempImageUrl" class="mb-4" style="overflow: hidden">
          <img
            :src="tempImageUrl"
            :alt="fullName"
            style="
              width: 100%;
              height: auto;
              object-fit: contain;
              border-radius: 8px;
            "
          />
        </div>
      </div>
      <a-progress
        :stroke-color="{
          from: '#108ee9',
          to: '#87d068',
        }"
        v-if="progress.value > 0"
        :percent="progress.value"
        status="active"
      />
      <template #footer>
        <a-button key="back" @click="cancelUpload" :disabled="loading">
          {{ $t("all.cancel") }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :disabled="!tempFile || loading"
          :loading="loading"
          @click="confirmUpload"
        >
          {{ $t("all.save") }}
        </a-button>
      </template>
    </a-modal>
    <a-modal
      v-model:visible="deleteModalVisible"
      :title="$t('profil.removeStudentPhoto')"
      :maskClosable="false"
      :closable="false"
      centered
    >
      <div class="text-center mb-4">
        <img
          v-if="profileImage"
          :src="settings.resourcesUrl.replace('FILE_PATH', profileImage)"
          :alt="fullName"
          style="
            width: 100%;
            max-width: 300px;
            height: auto;
            object-fit: contain;
            border-radius: 8px;
            opacity: 0.7;
          "
        />
        <p class="mt-4 mb-0">{{ $t("profil.confirmDelete") }}</p>
      </div>
      <template #footer>
        <a-button
          key="back"
          @click="deleteModalVisible = false"
          :disabled="loading"
        >
          {{ $t("all.cancel") }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          danger
          @click="confirmDeleteImage"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("action.supprimer") }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import router from "@/router";
import { mapState } from "vuex";
import { uploadFilesToS3 } from "@/services/uploadService";
import apiClient from "@/services/axios";

export default {
  name: "ProfileCard",
  computed: mapState(["settings"]),
  data() {
    return {
      imageModalVisible: false,
      uploadModalVisible: false,
      deleteModalVisible: false,
      tempFile: null,
      tempImageUrl: null,
      loading: false,
      progress: {
        value: 0,
      },
    };
  },
  props: {
    id: {
      required: true,
    },
    profileImage: {
      required: false,
    },
    fullName: {
      required: false,
    },
    classRoom: {
      required: false,
    },
    classRoomId: {
      required: false,
    },
    birthDay: {
      required: true,
    },
  },
  methods: {
    go() {
      router.push("/inscriptionScolarite/" + this.classRoomId);
    },
    calculateAge: function (date) {
      const birthday = new Date(date);
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    handleImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/bmp",
      ];
      const allowedTypesLabel = "JPEG, JPG, PNG, BMP";
      if (!allowedTypes.includes(file.type)) {
        this.$message.error(this.$t("error.allowedImageTypes", { types: allowedTypesLabel }));
        event.target.value = "";
        return;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(this.$t("error.image"));
        event.target.value = "";
        return;
      }

      this.tempFile = file;
      this.tempImageUrl = URL.createObjectURL(file);
      this.uploadModalVisible = true;
      this.$message.success(
        this.$t("success.imageTelecharge", { name: file.name })
      );
      event.target.value = ""; // Reset input
    },
    cancelUpload() {
      this.tempFile = null;
      this.tempImageUrl = null;
      this.uploadModalVisible = false;
      this.progress.value = 0;
      this.loading = false;
    },
    async confirmUpload() {
      if (!this.tempFile || !this.id) return;

      this.loading = true;
      try {
        const [uploadedKey] = await uploadFilesToS3(
          [this.tempFile],
          "manager/student",
          this.progress
        );
        await apiClient.patch(`/students/${this.id}`, {
          data: { photo: uploadedKey },
        });
        this.profileImage = uploadedKey;
        this.$message.success(this.$t("success.studentPhotoUploaded"));
        this.cancelUpload();
      } catch (error) {
        this.$message.error(this.$t("error.studentPhotoUploadError"));
      } finally {
        this.loading = false;
        this.progress.value = 0;
      }
    },
    async confirmDeleteImage() {
      this.loading = true;
      try {
        await apiClient.patch(`/students/${this.id}`, {
          data: { photo: "" },
        });
        this.profileImage = "";
        this.$message.success(this.$t("success.studentPhotoDeleted"));
      } catch (error) {
        this.$message.error(this.$t("error.studentPhotoDeleteError"));
      } finally {
        this.loading = false;
        this.deleteModalVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";

.imageWrapper {
  display: block;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}

.dropdownMenu {
  :global {
    .ant-dropdown-menu {
      border-radius: 55px !important;
    }

    .ant-dropdown-menu-item {
      display: flex;
      align-items: center;
      height: 35px;
      padding: 0 12px;
      margin: 2px 0;
    }
  }
}
</style>
